import { render, staticRenderFns } from "./BrokerLeads.vue?vue&type=template&id=4585eb36"
import script from "./BrokerLeads.vue?vue&type=script&lang=js"
export * from "./BrokerLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports